import { FormProvider, useForm } from "react-hook-form";
import { FiX } from "react-icons/fi";
import {
  useGetEmployeeByContainerIdQuery,
  useGetHrDepartmentsQuery,
} from "../../../../../../api/hrApi";
import DashboardStyle from "../../../../../../dashboard/Styles/Dashboard.module.css";
import {
  FormInput,
  FormSelect,
  FormTemplate,
  FormTextArea,
} from "../../../../../Components/Forms/InputTemplate";
import people from "../../../../../Images/grad.svg"; 
import { GetDepartment } from "../../../../../../../utils/redux/Employee/EmployeeSlice"; 
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetEmployees } from "../../../../../../../utils/redux/Global/GlobalSlice";


const CreateCommitteeIndexModal = ({
  isOpen,
  setIsOpen,
  onValidate = () => {},
  openNext = (rev) => rev,
  cachedData = null,
}) => {
  const { data: department, isLoading } = useGetHrDepartmentsQuery({
    PageSize: 1000,
    PageNumber: 1,
  });

  const colorOptions = [
    { value: 0, label: "Red" },
    { value: 1, label: "Yellow" },
    { value: 2, label: "Blue" },
    { value: 3, label: "Black" },
    { value: 4, label: "White" },
    { value: 5, label: "Green" },
  ];
  const formMethods = useForm({
    mode: "all",
    defaultValues: cachedData || {},
  });
  const {
    handleSubmit,
    formState: { isValid },
    watch,
  } = formMethods;
  const id = watch("departmentId");
  // const { data } = useGetEmployeeByContainerIdQuery(id);
// const {data} = useGetDepartmentQuery({pageSIze: 9999, DepartmentId: id}) 
const dispatch = useDispatch();
const data = useSelector(
    (state) => state?.employee?.get_department?.result
  );
useEffect(() => {
dispatch(
        GetDepartment({
          pageNumber: 1,
          pageSize: 10000,
          DepartmentId: id, hideError: true
        })
      );
},[id])
  const submit = (data) => {
    // Validate required fields
    if (
      !data.title ||
      !data.description ||
      !data.departmentId ||
      !data.committeeHeadId
    ) {
      console.error("Please fill in all required fields");
      return;
    }

    // If validation passes, call onValidate with the data
    console.log("Committee form validation passed:", data);
    onValidate(data);
    openNext(data);
  };

  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h4 className="text-[25px] font-[500]">Set Up </h4>
          <h1 className="text-[28px] font-[800]">Committee List </h1>
          <p>Define and manage committee list.</p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        {isLoading && <small>Loading...</small>}
        <div>
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <FormInput
                title={"Committee Title"}
                camelCase={"title"}
                placeholder={"select"}
              />
              <FormTextArea
                className="h-[200px]"
                title={"Commitee Description"}
                camelCase={"description"}
              />
              <div className="border-1 rounded-md p-2 mt-2 border-[#A0BDA2]">
                <FormSelect
                  title={"Department"}
                  camelCase={"departmentId"}
                  placeholder={"select"}
                  array={department?.responseObject?.pageItems?.map((opt) => (
                    <option key={opt.value} value={opt.id}>
                      {opt.name}
                    </option>
                  ))}
                  defaultValue={0}
                />
                <FormSelect
                  title={"Committee Head"}
                  camelCase={"committeeHeadId"}
                  placeholder={"select"}
                  array={data?.map((opt) => (
                    <option key={opt.value} value={opt.id}>
                      {opt.firstName} {opt.surname}
                    </option>
                  ))}
                  defaultValue={0}
                />
              </div>
              <div className="flex justify-between my-4">
                <div className="w-2" />
                <button
                  type="submit"
                  className="bg-[#18BB0C1A] text-[#18BB0C] px-5 py-2 rounded-sm flex items-center space-x-2"
                >
                  <img src={people} alt="people grag icon" />{" "}
                  <span>Add Member</span>
                </button>
              </div>
            </FormTemplate>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default CreateCommitteeIndexModal;
